import { useMutation } from "@apollo/client/react";
import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

import { AzureIntegrationView } from "../../useSearchCloudIntegrations/gql";
import AzureIntegrationDeleteConfirmationContent from "./Content";
import { DELETE_AZURE_INTEGRATION } from "./gql";

type DeleteConfirmationProps = {
  integration: AzureIntegrationView;
  refetchQueriesOnDelete?: string[];
  onDeleteSuccess?: () => void;
};

const AzureIntegrationDeleteConfirmation = create(function DeleteConfirmation({
  integration,
  onDeleteSuccess,
  refetchQueriesOnDelete,
}: DeleteConfirmationProps) {
  const modal = useModal();

  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [deleteIntegration, { loading }] = useMutation(DELETE_AZURE_INTEGRATION, {
    awaitRefetchQueries: true,
    refetchQueries: refetchQueriesOnDelete,
  });

  const onConfirm = () => {
    deleteIntegration({ variables: { id: integration.id } })
      .then((data) => {
        if (data?.data?.azureIntegrationDelete?.id) {
          reportSuccess({ message: "Integration successfully removed" });
          modal.hide();
          onDeleteSuccess?.();
        }
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete integration"
      onConfirm={onConfirm}
      isLoading={loading}
      isDismissable={!loading}
    >
      <AzureIntegrationDeleteConfirmationContent integration={integration} />
    </DeleteConfirmationModal>
  );
});

export const showAzureIntegrationDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(AzureIntegrationDeleteConfirmation, props);
